import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('tag', index);
Router.get('tag/:any', form);
